
import { SSR_CODES, CLASS_LABELS } from '../../../utils/configs';

export const SeatCellRenderer = (props) => {
  const { value } = props;
  if (!value) return null;

  return (
    <span
      style={{
        background: 'rgba(76, 195, 230, 0.2)',
        color: '#7dd8ef',
        padding: '0.2rem 0.4rem',  
        borderRadius: '6px',
        fontWeight: '700',   
        fontSize: '0.75rem',  
        border: '1px solid rgba(76, 195, 230, 0.5)',
        display: 'inline-block',
        whiteSpace: 'nowrap',   
        height: 'fit-content', 
        lineHeight: '1.2',  
         
      }}
      title={`Seat ${value}`}
    >
      {value}
    </span>
  );
};

export const NameCellRenderer = (props) => {
  const { data } = props;
  if (!data?.name) return null;

  return (
    <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
      {data?.title && (
        <span
          style={{
            color: '#4f6a87ff',
            fontSize: '0.8rem',
            fontWeight: '600',
            whiteSpace: 'nowrap'
          }}
          title={data.title}
        >
          {data.title}
        </span>
      )}
      <span style={{fontSize: '0.85rem'}}>
        {data.name}
      </span>
    </div>
  );
};

/**
 * PNR Renderer */
export const PNRCellRenderer = (props) => {
  const { value } = props;
  if (!value) return null;

  return (
    <span
      style={{
        color: '#4cc3e6',
        fontWeight: '600',
        fontSize: '0.78rem',
        letterSpacing: '0.5px'
      }}
    >
      {value}
    </span>
  );
};

/**
 class
 */
export const CLASS_COLORS = {
  'EC': { bg: 'rgba(59, 130, 246, 0.15)', text: '#3b82f6', border: 'rgba(59, 130, 246, 0.4)' },
  'CP': { bg: 'rgba(245, 158, 11, 0.15)', text: '#f59e0b', border: 'rgba(245, 158, 11, 0.4)' },
  'AV': { bg: 'rgba(168, 85, 247, 0.15)', text: '#a855f7', border: 'rgba(168, 85, 247, 0.4)' },
  'BU': { bg: 'rgba(239, 68, 68, 0.15)', text: '#ef4444', border: 'rgba(239, 68, 68, 0.4)' },
  'F': { bg: 'rgba(236, 72, 153, 0.15)', text: '#ec4899', border: 'rgba(236, 72, 153, 0.4)' }
};

export const CLASS_COLOR_FALLBACK = {
  bg: 'rgba(107, 114, 128, 0.15)',
  text: '#6b7280',
  border: 'rgba(107, 114, 128, 0.3)'
};

export const ClassCellRenderer = (props) => {
  const { value } = props;
  if (!value) return null;

  const style = CLASS_COLORS[value] || CLASS_COLOR_FALLBACK;

  const label = CLASS_LABELS[value] || value;

  return (
    <span
      style={{
        background: style.bg,
        color: style.text,
        padding: '0.2rem 0.4rem',  
        borderRadius: '4px',
        fontWeight: '700',   
        fontSize: '0.75rem',  
        display: 'inline-block',
        whiteSpace: 'nowrap', 
        height: 'fit-content',   
        lineHeight: '1.2',  
        
        border: `1px solid ${style.border}`  
      }}
      title={label}
    >
      {label}
    </span>
  );
};
 
export const NationalityCellRenderer = (props) => {
  const { value } = props;
  if (!value) return null;

  return (
    <span
      style={{
        background: 'rgba(76, 195, 230, 0.15)',
        color: '#7dd8ef',
        padding: '0.2rem 0.4rem',   
        borderRadius: '4px',
        fontWeight: '700',
        fontSize: '0.75rem',  
        display: 'inline-block',
        whiteSpace: 'nowrap',  
        height: 'fit-content',   
        lineHeight: '1.2',         
        border: '1px solid rgba(76, 195, 230, 0.45)'  
      }}
      title={`Country: ${value}`}
    >
      {value}
    </span>
  );
};

/**
 * Contact Renderer
  
 */
export const ContactCellRenderer = (props) => {
  const { data } = props;
  if (!data?.mobile && !data?.email) {
    return (
      <span style={{ color: '#3d5a7a', fontSize: '0.9rem' }}>—</span>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        gap: '0.4rem', 
        alignItems: 'center',
        height: 'fit-content',  
        lineHeight: '1' ,
        paddingTop: '0.5rem'
      }}
    >
      {data?.mobile && (
        <span
          title={data.mobile}
          style={{
          
            fontSize: '0.8rem', 
            display: 'inline-flex',   
            alignItems: 'center',
            justifyContent: 'center'
          }}
          
        >
          {data.mobile}
        </span>
      )}
      {data?.email && (
        <span
          title={data.email}
          style={{            
            fontSize: '0.8rem', 
            display: 'inline-flex', 
            alignItems: 'center',
            justifyContent: 'center'
          }}   
        >
         {data.email}
        </span>
      )}
    </div>
  );
};


export const SSRCellRenderer = (props) => {
  const { data } = props;
  
  if (!data || !data.ssrs || !Array.isArray(data.ssrs) || data.ssrs.length === 0) {
    return <span style={{ color: '#3d5a7a' }}>—</span>;
  }

  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '0.25rem',
        alignItems: 'center',
        maxWidth: '280px',
        paddingTop: '0.3rem',
        lineHeight: '1.2'
      }}
    >
      {data.ssrs.map((ssr, idx) => {
        const ssrCode = ssr.ssrCode || ssr.code || '';
        const ssrNumber = ssr.ssrNumber || ssr.number || '?';
        const ssrFullName = SSR_CODES[ssrCode] || ssrCode;  // ✅ Get full name

        return (
          <div
            key={`${ssrCode}-${idx}`}
            style={{
              display: 'inline-block',
              background: '#3ecf8e',
              color: '#0c1526',
              borderRadius: '3px',
              padding: '0.25rem 0.35rem',
              fontSize: '0.7rem',
              fontWeight: '600',
              whiteSpace: 'nowrap',
              height: 'fit-content',
              border: '1px solid rgba(30, 120, 80, 0.4)'
            }}
            title={`${ssrCode}: ${ssrFullName}`} 
            
          >
            {ssrCode}
            <span style={{ opacity: 0.8 }}>({ssrNumber})</span>
          </div>
        );
      })}
    </div>
  );
};

/**
 * Status Renderer
 * Color-coded passenger status
 */
export const StatusCellRenderer = (props) => {
  const { value } = props;
  if (!value) return null;

  const statusColors = {
    '1': { bg: 'rgba(34, 197, 94, 0.15)', text: '#22c55e', label: 'Checked In' },
    '2': { bg: 'rgba(249, 115, 22, 0.15)', text: '#f97316', label: 'Boarded' },
    '3': { bg: 'rgba(59, 130, 246, 0.15)', text: '#3b82f6', label: 'Cancelled' },
    '0': { bg: 'rgba(107, 114, 128, 0.15)', text: '#6b7280', label: 'No Show' }
  };

  const style = statusColors[String(value)] || {
    bg: 'rgba(107, 114, 128, 0.15)',
    text: '#6b7280',
    label: 'Unknown'
  };

  return (
    <span
      style={{
        background: style.bg,
        color: style.text,
        padding: '0.2rem 0.4rem',
        borderRadius: '4px',
        fontWeight: '700',
        fontSize: '0.75rem',
        display: 'inline-block',
        whiteSpace: 'nowrap',
         
        border: `1px solid rgba(${style.text}, 0.3)`,
        lineHeight: '1.2'   
      }}
    >
      {style.label}
    </span>
  );
};
 
export const DefaultCellRenderer = (props) => {
  const { value } = props;
  if (!value) {
    return (
      <span style={{ color: '#3d5a7a' }}>—</span>
    );
  }

  return (
    <span style={{ color: '#d6eaf8' }}>
      {value}
    </span>
  );
};